// ANCHOR GraphQL
import { Form_Scoring_Policies_Enum as ScoringPolicy } from '@lyon/graphql/types';

export const RADIO_NAME = 'Select scoring policy for retakes';

export const RADIOS = [
  {
    value: ScoringPolicy.Latest,
    label: 'Latest',
    description: "The student's latest attempt will be recorded.",
  },
  {
    value: ScoringPolicy.Highest,
    label: 'Highest',
    description: "The student's attempt with the highest score will be recorded.",
  },
];
